import { OxfordCategory, ProjectSubType, ProjectType } from '@prisma/client';

export const projectTypeToFriendlyLabel: Record<ProjectType, string> = {
  [ProjectType.REFORESTATION]: 'Reforestation',
  [ProjectType.FORESTRY]: 'Forestry',
  [ProjectType.CAPTURE]: 'Capture',
  [ProjectType.WETLANDS]: 'Wetlands',
  [ProjectType.RENEWABLES]: 'Renewables',
  [ProjectType.COMMUNITY]: 'Community',
  [ProjectType.TRANSPORT]: 'Transport',
  [ProjectType.GEOTHERMAL]: 'Geothermal',
  [ProjectType.HOUSEHOLD_RETROFIT]: 'Household Retrofit',
  [ProjectType.AFFORESTATION_REFORESTATION_AND_REVEGETATION]: 'Afforestation, reforestation and revegetation',
  [ProjectType.BIOCHAR]: 'Biochar',
  [ProjectType.BLUE_CARBON]: 'Blue carbon',
  [ProjectType.DIRECT_AIR_CAPTURE]: 'Direct air capture',
  [ProjectType.ENHANCED_ROCK_WEATHERING]: 'Enhanced rock weathering',
  [ProjectType.REGENERATIVE_AGRICULTURE]: 'Regenerative agriculture',
  [ProjectType.WILDFLOWERS]: 'Wildflowers',
  [ProjectType.SEAGRASS]: 'Seagrass',
  [ProjectType.PEATLANDS]: 'Peatlands',
  [ProjectType.RAINFOREST_PROTECTION]: 'Rainforest protection',
  [ProjectType.MARINE_PROTECTION_RESTORATION]: 'Marine protection and restoration',
};

export const projectSubTypeToFriendlyLabel: Record<ProjectSubType, string> = {
  [ProjectSubType.GLOBAL_REFORESTATION]: 'Global reforestation',
  [ProjectSubType.UK_REFORESTATION]: 'UK reforestation',
  [ProjectSubType.US_REFORESTATION]: 'US reforestation',
  [ProjectSubType.BRAZIL_REFORESTATION]: 'Brazil reforestation',
  [ProjectSubType.AUSTRALIA_REFORESTATION]: 'Australia reforestation',
  [ProjectSubType.WIND]: 'Wind',
  [ProjectSubType.SOLAR]: 'Solar',
  [ProjectSubType.HYDRO]: 'Hydro',
  [ProjectSubType.BIOMASS]: 'Biomass',
  [ProjectSubType.FOREST_PROTECTION]: 'Forest protection',
};

export const oxfordCategoryToFriendlyLabel: Record<OxfordCategory, string> = {
  [OxfordCategory.CATEGORY_I]: 'Category I: Avoided or reduced emissions from the geosphere (without storage)',
  [OxfordCategory.CATEGORY_II]: 'Category II: Avoided or reduced emissions from the biosphere',
  [OxfordCategory.CATEGORY_III]: 'Category III: Reduced emissions from the geosphere (with storage)',
  [OxfordCategory.CATEGORY_IV]: 'Category IV: Carbon removal to the biosphere',
  [OxfordCategory.CATEGORY_V]: 'Category V: Carbon removal to the geosphere',
};
